import React from 'react';
import { Tooltip } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
export var ToolTip = function (_a) {
    var label = _a.label;
    return (React.createElement(Tooltip, { placement: "left", title: label, "data-testid": "NationalAccountTooltip" },
        React.createElement(InfoFilled, { size: "small", color: "info" })));
};
